module.exports = __webpack_public_path__ + "static/media/youtube-white.074565e2.png";